import Immutable from 'seamless-immutable'
import { createReducer } from 'reduxsauce'

// import config from '../Config'
import { Types } from './actions'

export const INITIAL_STATE = Immutable({
  isReconnecting: false,
  pingResponse: true,
  previouslyConnected: false,
  reconnectAttempts: 0,
  socketConnected: false,
  socketConnecting: false,
  userIsBanned: false,
  // Errors
  hasError: false,
  pingResponseError: false,
  error: '',
})

const stopWebSocket = (state) => state.merge({ socketConnected: false })
const resetWebSocket = (state) => state.merge({ ...INITIAL_STATE })
const reconnectWebSocket = (state) => state.merge({ reconnectAttempts: state.reconnectAttempts + 1 })

const banUser = (state) => state.merge({ userIsBanned: true, hasError: true })
const socketConnectAttempt = (state) => state.merge({ socketConnecting: true })
const socketConnectSuccess = (state) =>
  state.merge({
    error: INITIAL_STATE.error,
    hasError: INITIAL_STATE.hasError,
    isReconnecting: INITIAL_STATE.isReconnecting,
    pingResponseError: INITIAL_STATE.pingResponseError,
    pingResponse: INITIAL_STATE.pingResponse,
    previouslyConnected: true,
    reconnectAttempts: 0,
    socketConnected: true,
    socketConnecting: false,
  })
const socketConnectFailure = (state, action) =>
  state.merge({ socketConnecting: false, error: action.error, hasError: true })
const socketErrorNotification = (state, action) => {
  console.log('socket error received: ', action.error)
  return state.merge({ error: action.error })
}
const pong = (state) => state.merge({ pingResponse: true })

const setPingResponse = (state, { responded }) => state.merge({ pingResponse: responded })

const setPingResponseError = (state, { error }) => state.merge({ pingResponseError: error })

const setIsReconnecting = (state, { reconnect }) => state.merge({ isReconnecting: reconnect })

const error = (state, { result }) => state.merge({ hasError: true, error: result })

const ACTION_HANDLERS = {
  [Types.STOP_WEB_SOCKET]: stopWebSocket,
  [Types.RESET_WEB_SOCKET]: resetWebSocket,
  [Types.RECONNECT_WEB_SOCKET]: reconnectWebSocket,

  [Types.BAN_USER]: banUser,
  [Types.SOCKET_CONNECT_ATTEMPT]: socketConnectAttempt,
  [Types.SOCKET_CONNECT_SUCCESS]: socketConnectSuccess,
  [Types.SOCKET_CONNECT_FAILURE]: socketConnectFailure,
  [Types.SOCKET_ERROR_NOTIFICATION]: socketErrorNotification,

  [Types.PONG]: pong,
  [Types.SET_PING_RESPONSE]: setPingResponse,
  [Types.SET_PING_RESPONSE_ERROR]: setPingResponseError,
  [Types.SET_IS_RECONNECTING]: setIsReconnecting,

  [Types.ERROR]: error,
}

export default createReducer(INITIAL_STATE, ACTION_HANDLERS)
